import { useEffect } from "react";

import { useAppSelector, useOfflineModeSelector } from "@/hooks/redux";

let hasRun = false;

const warmups = [
    import("@/shared/forms/RichTextEditor"),
    import(
        "@/app/ModalsContainer/Modals/CustomTask/CreateCustomTaskModal/components/PhotoEditorModal"
    ),
    import(
        "@/domains/media/components/GalleryUploader/Camera/modes/EditingMode"
    ),
];

export const useLazyWarmups = () => {
    const offlineMode = useOfflineModeSelector();
    const isInitialDataLoading = useAppSelector(
        (s) => s.offline.isInitialDataLoading,
    );

    useEffect(() => {
        if (offlineMode) return;
        if (isInitialDataLoading) return;
        if (hasRun) return;

        hasRun = true;

        void Promise.allSettled(warmups);
    }, [offlineMode, isInitialDataLoading]);
};
